// Kit-internal link between <FormField> and the control slotted into it, so the
// label, error and helper text are tied to the control for assistive tech
// (BUG-037) without every form passing ids by hand. FormField provides; Input,
// NumberInput, Textarea, DatePicker and Select inject. A control rendered
// outside a FormField gets `undefined` and renders exactly as before.

import { inject, provide, type ComputedRef, type InjectionKey } from 'vue'

export interface FormFieldContext {
  /** Id for the control's focusable element — the label's `for`. */
  controlId: string
  /** Id of the visible label, for controls a `for` can't target (Select). */
  labelId: string
  /** Id of the error / helper text when shown — for `aria-describedby`. */
  describedBy: ComputedRef<string | undefined>
  /** True while the field shows an error — for `aria-invalid`. */
  invalid: ComputedRef<boolean>
}

const FORM_FIELD_CONTEXT: InjectionKey<FormFieldContext> = Symbol('form-field-context')

export function provideFormFieldContext(context: FormFieldContext): void {
  provide(FORM_FIELD_CONTEXT, context)
}

export function useFormFieldContext(): FormFieldContext | undefined {
  return inject(FORM_FIELD_CONTEXT, undefined)
}
